var _ellipse, _ellipse2, _g, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAirplaneWithBackground = function SvgAirplaneWithBackground(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 166,
    viewBox: "0 0 165 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.702,
    cy: 82.4823,
    rx: 82.2977,
    ry: 82.4491,
    fill: "#FFE0E9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_427_6407",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 165,
    height: 166
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.2977,
    cy: 82.5839,
    rx: 82.2977,
    ry: 82.4491,
    fill: "#FFE0E9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_427_6407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6803 79.7636L-6.38477 132.153",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0943 90.6796L-3.9707 143.069",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4713 100.558L-1.59375 152.948",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 56L144 22L146.5 23L126.5 101.5L124 104L99 88L84 105.5L71.5 68.5L46.5 56Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8785 103.797L81.9941 75.5312L98.9535 86.8375L83.8785 103.797Z",
    fill: "#FFE0E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.507 88.4081L85.432 105.368L82.6152 102.864L97.6903 85.9043L100.507 88.4081Z",
    fill: "#FC628F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.05 22.9853C128.915 28.0112 107.346 35.6402 88.5532 42.2027C69.8273 48.7419 53.684 54.2845 50.5599 55.0656C49.1783 55.4109 48.4985 55.7852 48.2017 56.0311C48.1518 56.0725 48.1178 56.1051 48.0953 56.1292C48.1226 56.1964 48.1862 56.321 48.3324 56.501C48.5335 56.7484 48.81 56.9985 49.1059 57.213L72.5141 66.2161L132.017 29.027C132.854 28.5038 133.953 28.7152 134.536 29.5116C135.119 30.3079 134.989 31.4193 134.237 32.0594L85.1372 73.8857C96.3925 82.4806 116.658 97.8544 120.871 100.663C122.733 101.905 123.738 101.674 124.22 101.436C124.844 101.129 125.327 100.442 125.553 99.8156C128.38 88.1923 132.703 70.5253 136.511 55.186C140.311 39.8765 143.635 26.7293 144.419 24.3759C144.727 23.451 144.713 22.9837 144.683 22.8144C144.597 22.789 144.421 22.7575 144.133 22.7727C143.779 22.7913 143.389 22.8739 143.05 22.9853ZM48.0546 56.1818C48.054 56.1819 48.0557 56.178 48.0611 56.1702C48.0578 56.1779 48.0551 56.1818 48.0546 56.1818ZM148.359 21.981C148.597 23.0617 148.425 24.2751 147.994 25.5677C147.271 27.7368 144 40.6567 140.168 56.0939C136.353 71.4634 132.02 89.1735 129.194 100.792C129.182 100.843 129.167 100.893 129.151 100.943C128.737 102.184 127.725 103.909 125.889 104.816C123.889 105.803 121.44 105.572 118.78 103.799C114.191 100.74 91.633 83.5986 80.9931 75.4622C80.5408 75.1162 80.2691 74.5843 80.2541 74.015C80.2391 73.4457 80.4823 72.9001 80.9158 72.5308L112.308 45.7891L73.7141 69.9104C73.212 70.2242 72.5916 70.2838 72.0389 70.0712L47.542 60.6494C47.4124 60.5995 47.2887 60.5355 47.1732 60.4585C46.585 60.0664 45.9366 59.5288 45.4075 58.8776C44.8961 58.2482 44.3587 57.3416 44.3102 56.2413C44.2564 55.0229 44.8146 53.9431 45.7973 53.129C46.7136 52.3699 48.0123 51.8177 49.6458 51.4093C52.5516 50.6829 68.443 45.2333 87.3107 38.6446C106.103 32.0823 127.676 24.4518 141.807 19.4275L141.842 19.415L141.842 19.4153C142.442 19.2154 143.176 19.0491 143.935 19.0091C144.672 18.9703 145.595 19.0422 146.449 19.4764C147.386 19.9535 148.099 20.8024 148.359 21.981Z",
    fill: "#FC628F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0231 104.115L72.7168 68.312L144.18 22.7686L82.1387 73.9651L84.0231 104.115Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.704 21.6602C146.289 22.4657 146.147 23.5879 145.379 24.2217L84.0791 74.8066L85.9036 103.997C85.963 104.948 85.304 105.793 84.3679 105.967C83.4318 106.142 82.5127 105.59 82.2259 104.682L70.9197 68.8792C70.6628 68.0657 70.9844 67.1811 71.7038 66.7227L143.167 21.1792C144.007 20.644 145.118 20.8547 145.704 21.6602ZM74.949 69.1235L81.1813 88.859L80.2578 74.0824C80.2201 73.4799 80.4734 72.8957 80.9391 72.5115L119.286 40.8678L74.949 69.1235Z",
    fill: "#FC628F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAirplaneWithBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/airplane-with-background.43a0469d9c8125386ebe4fe4ddace1ef.svg";